const React = require("react");

const DesktopView = require("./DesktopView");
const MobileView = require("./MobileView");

export default ({mobile, ...props}) => {
  const Main = mobile
    ? MobileView
    : DesktopView;

  return <Main {...props} />;
}
